// extracted by mini-css-extract-plugin
export default {"sectionItemCell":"app-react-edge-components-CertificateModal-CertificateModal-module__sectionItemCell"};